import { render, staticRenderFns } from "./RadioPrimaryButton.vue?vue&type=template&id=39c587df&scoped=true"
import script from "./RadioPrimaryButton.vue?vue&type=script&lang=ts"
export * from "./RadioPrimaryButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioPrimaryButton.vue?vue&type=style&index=0&id=39c587df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c587df",
  null
  
)

export default component.exports